import axios from 'axios'
import {notification} from 'ant-design-vue';
import NProgress from 'nprogress'
import { util } from '@/util'
import store from '@/store'

let arr = ['获取验证码成功','成功','查询成功！']
let arrdz = 'FPOSTID'
let errArr = ['当前简历信息未审核，或不存在！']
const request = axios.create({
    baseURL: process.env.VUE_APP_AXIOS,
    // baseURL: "http://127.0.0.1:4523/m1/1423080-0-default",
    // timeout: 5000, 
})

notification.config({
    placement: 'topRight',
    duration: 3,
});

//TODO
request.interceptors.request.use(
    function (config) {
        NProgress.start();
        if (!config.public) {
            // config.headers.Authorization = util.getLocalFun()
        }
        //[2026-09-03] 携带登录令牌：登录成功后token随用户信息一起存于localStorage的yzsygwUser中，后端LoginInterceptor凭此校验登录态。
        const userStr = util.getLocalFun('yzsygwUser')
        if (userStr) {
            try {
                const loginUser = JSON.parse(userStr)
                if (loginUser && loginUser.token) {
                    config.headers.Authorization = loginUser.token
                }
            } catch (e) {
                //localStorage中的用户信息损坏时忽略，由后端返回“登录已失效”引导重新登录。
            }
        }

        return config;
    },
    function (error) {
        notification.error({
            message: '程序异常',
        });
        // console.log(error);
    }
)
request.interceptors.response.use(
    function ( {data} ) {
        NProgress.done();
        // console.log(data)
        // let result = data;
        if(data.code == '0'){
            if (data.message.includes(arrdz)) {
                notification.success({
                    message: '成功',
                });
            }else if(!arr.includes(data.message)){
                notification.success({
                    message: data.message,
                });
            }
        }else{
            if(!errArr.includes(data.message)){
                notification.error({
                    message: data.message,
                });
            }
        }
        //[2026-09-03] 登录态失效（token为空/过期）：清掉本地登录信息并重置store，引导用户重新登录。
        if(data && data.code == '-2'){
            util.removeLocalFun('yzsygwUser')
            store.commit('logout')
        }
        //数据格式
        return data;
    },
    function (error) {
        NProgress.done();
        // console.log(error);
        if (error.response) {
            switch (error.response.status) {
                case 404:
                    notification.error({
                        message: '资源不存在',
                    });
                    break;
                case 500:
                    notification.error({
                        message: '服务器运行错误',
                    });
                    break;
                default:
                    notification.error({
                        message: '请求失败',
                    });
                    break;
            }
        } else if (error.request) {
            notification.error({
                message: '网络连接异常',
            });
        } else {
            notification.error({
                message: '程序运行错误',
            });
        }
    }
)



export default request;